import React from "react"
import * as Icon from "react-feather"
import FontAwesomeIcon from "react-fontawesome"
const optionsMenuConfig = [
  
  {
    id: "accidenttype",
    title: "Accident Types",
    type: "item",
    // icon: <Icon.AlertCircle size={20} />,
    icon:<Icon.PlusSquare size={20}/>,
    permissions: ["admin", "editor"],
    navLink: "/accidenttypes",

  },
  {
    id: "additionalflag",
    title: "Additional Flag",
    type: "item",
    // icon: <Icon.AlertCircle size={20} />,
    icon:<Icon.Flag size={20}/>,
    permissions: ["admin", "editor"],
    navLink: "/additionalflag",

  },
  {
    id: "ailmenttypes",
    title: "Ailment Types",
    type: "item",
    icon: <Icon.Activity size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/ailmenttypes",

  },
  {
    id: "billingclass",
    title: "Billing Classes",
    type: "item",
    icon: <Icon.BarChart2 size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/billingclasses",

  },
  {
    id: "bodysites",
    title: "Body Sites",
    type: "item",
    icon: <Icon.Eye size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/bodysites",

  },
  {
    id: "mngdepartments",
    title: "Departments",
    type: "item",
    icon: <Icon.Package size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/departments",

  },
  {
    id: "financialclases",
    title: "Financial Classes",
    type: "item",
    icon: <Icon.DollarSign size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/financialclasses",

  },
  {
    id: "gennotifieruser",
    title: "GenNotifier Users",
    type: "item",
    icon: <Icon.UserCheck size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/gennotifieruserlist",

  },
  {
    id: "grossdescription",
    title: "Gross Description",
    type: "item",
    icon: <Icon.Inbox size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/grossdescription",

  },
  {
    id: "icdcodelist",
    title: "ICD Codes",
    type: "item",
    icon: <Icon.Link2 size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/icdcodelist",

  },
  {
    id: "masterlist",
    title: "Master List",
    type: "item",
    icon: <Icon.Anchor size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/masterlist",

  },
  {
    id: "microcodes",
    title: "Microcodes",
    type: "item",
    icon: <Icon.Pocket size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/microcodes",

  },
  
  {
    id: "pathologists",
    title: "Pathologists",
    type: "item",
    icon: <Icon.UserPlus size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/pathologists",

  },
  {
    id: "probelots",
    title: "Probe Lots",
    type: "item",
    icon: <Icon.Filter size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/probelots",

  },
  {
    id: "probesets",
    title: "Probe Sets",
    type: "item",
    icon: <Icon.Image size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/probesets",

  },
  {
    id: "procedures",
    title: "Procedures",
    type: "item",
    icon: <Icon.Feather size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/procedurelist",

  },
  {
    id: "resultslist",
    title: "Results",
    type: "item",
    icon: <Icon.Codesandbox size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/resultslist",

  },
  {
    id: "resultcategory",
    title: "Result Category",
    type: "item",
    icon: <Icon.Command size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/resultcategory",

  },
  {
    id: "screeners",
    title: "Screeners",
    type: "item",
    icon: <Icon.Sunrise size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/screeners",

  },
  {
    id: "submittingfacility",
    title: "Submitting Facilities",
    type: "item",
    icon: <Icon.UploadCloud size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/submittingfacilities",

  },
  {
    id: "stainlist",
    title: "Stains",
    type: "item",
    icon: <Icon.Zap size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/stainlist",

  },
  {
    id: "tcpccenters",
    title: "TCPC Centers",
    type: "item",
    icon: <Icon.Unlock size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/tcpccenters",

  },
  {
    id: "tcpcpathologist",
    title: "TCPC Pathologists",
    type: "item",
    icon: <Icon.UserCheck size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/tcpcpathologists",

  },
  {
    id: "testgroups",
    title: "Test Groups",
    type: "item",
    icon: <Icon.Umbrella size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/testgroups",

  },
  {
    id: "tests",
    title: "Tests",
    type: "item",
    icon: <Icon.Type size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/tests",

  },
  {
    id: "users",
    title: "Users",
    type: "item",
    icon: <Icon.User size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/users",

  },

]

export default optionsMenuConfig
